import PropTypes from "prop-types"
import React from "react"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import { useTranslation } from "react-i18next"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import Unit from "views/atoms/reports/Unit"
import ChartBadge from "views/atoms/badges/ChartBadge"
import { round } from "services/units/round"
import Loading from "components/widgets/Loading"
import { useAppContext } from "components/AppContext"
import { useEntity } from "hooks/useAxios"
import useRequest from "hooks/useRequest"
import ScoreEntity from "services/entities/ScoreEntity"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"

const TextChartODD13GHGEmissionsFactorAverage = ({ trendBadge }) => {
  const { t } = useTranslation()
  const { currentNode, currentPeriod } = useAppContext()
  const scoreEntity = useEntity(ScoreEntity)

  const { data, isLoading, reload } = useRequest(
    () => scoreEntity.getOdd13GhgEmissionsFactorAverage(),
    [currentNode, currentPeriod],
    {
      condition: !!currentNode && currentNode?.has_purchases,
      cacheKey: `odd13-factor-avg-${currentNode?.id}-${currentPeriod?.id}`,
    }
  )
  if (isLoading) {
    return <Loading />
  }

  if (!data || data.kpi_value === null || data.kpi_value === undefined) {
    return null
  }

  const reference = (
    <ChartBadge
      value={data.kpi_value}
      lowerLimit={50}
      upperLimit={100}
      inverse
    />
  )

  const content = {
    reference: reference,
    kpi: round(data.kpi_value, 0),
    kpi_unit: (
      <Unit unit={t(`units:units.emission_per_euro.${data.kpi_unit}`)} />
    ),
    kpi_text: t(`score:score.13.textChartODD13GHGEmissionsFactorAverage.title`),
  }

  const content_for_display = (
    <TextChartMinor content={content} noSubtextHover />
  )

  return (
    <HelpWidgetChartInteractiveMolecule
      text={t(`score:score.13.textChartODD13GHGEmissionsFactorAverage.help`)}
    >
      <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto">
        <TextChart content={content_for_display} />
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

TextChartODD13GHGEmissionsFactorAverage.propTypes = {
  trendBadge: PropTypes.shape({
    symbol: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
}

TextChartODD13GHGEmissionsFactorAverage.defaultProps = {
  trendBadge: null,
}

export default TextChartODD13GHGEmissionsFactorAverage
